var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProwessIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-786 -1773)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    transform: "translate(786 1773)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(793 1788)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2000.893 1440.788)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1207.892 338.212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.271,68.921c-.013-.083-.027-.164-.04-.243-.892-2.56-1.135-7.114-.648-12.555,1.893-1.246,11.847-8.663,5.3-23.21-.048-.112-.1-.224-.154-.335a65.32,65.32,0,0,0-6.207-9.854c-.98-1.368-1.98-2.763-2.923-4.174-.687-1.022-1.342-2.055-1.932-3.088a6.458,6.458,0,0,0-7.969-3.12,5.236,5.236,0,0,0-3,2.848c-.005.011-.011.027-.016.037-10.972.586-19.851,8.033-19.542,18.014.043,1.432.293,3.529.287,4.9-.011,4.882-4.232,6.883-4.312,8.438-.133,2.55,2.859,1.751,3.918,5.361,1.336,4.578-.586,9.8,5.653,9.476,2.491-.1,6.537-1.065,8.273.548,1.107,1.027,2,5.51,2.342,7.5a1.148,1.148,0,0,0,1.134.953H48.171a1.151,1.151,0,0,0,1.107-1.469ZM36.85,56.161a1.655,1.655,0,0,1,1.326-.655,1.992,1.992,0,0,1,.426.043c1.65.325,4,2.6,5.387,6.244-4.046-.138-6.6-1.719-7.368-3.322A2.05,2.05,0,0,1,36.85,56.161ZM35.179,13.584a4.719,4.719,0,0,1,1.714-.314,5.287,5.287,0,0,1,4.615,2.859c.229.4.463.793.713,1.187,1.294,2.1,2.774,4.174,4.211,6.186a61.136,61.136,0,0,1,6.234,9.96A25.744,25.744,0,0,1,54.088,37.4c2.619,9.725-2.908,15.15-5.375,17.02.553-9.565-2.058-22.8-7.559-28.75a.666.666,0,1,0-.977.9c5.217,5.646,7.862,19.048,7.166,28.412-.242-.04-.539-.1-.89-.177-3.391-.825-11.344-4.1-12.76-16.763a31.088,31.088,0,0,1-.005-6.058,40.643,40.643,0,0,0-.974-13.2,4.635,4.635,0,0,1,.447-3.535.324.324,0,0,1,.037-.053,4.086,4.086,0,0,1,1.98-1.609Z",
    transform: "translate(-8.108 -8.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.88,23.449a3.768,3.768,0,0,0,2.934.117.442.442,0,0,0,.313-.495,3.772,3.772,0,0,0-1.366-2.6,3.772,3.772,0,0,0-2.934-.117.442.442,0,0,0-.312.494A3.774,3.774,0,0,0,86.88,23.449Z",
    transform: "translate(-44.304 -12.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.44,9.7a3.771,3.771,0,0,0,2.932-.16A3.771,3.771,0,0,0,41.7,6.925a.443.443,0,0,0-.319-.49,3.771,3.771,0,0,0-2.932.16,3.771,3.771,0,0,0-1.328,2.619A.443.443,0,0,0,37.44,9.7Z",
    transform: "translate(-21.674 -6.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.237,30.639a3.64,3.64,0,0,0-2.491-1.494c-3.152-.621-5.193,1.607-7.355,3.965a21.8,21.8,0,0,1-3.952,3.651.665.665,0,0,0,.73,1.113,22.79,22.79,0,0,0,4.2-3.865c2.067-2.254,3.7-4.035,6.117-3.558a2.4,2.4,0,0,1,1.639.923c.783,1.181.293,3.528-.327,6.5a43.327,43.327,0,0,0-1.2,9.5c.13,10.578-7.37,15.458-14.432,16.5a.665.665,0,0,0,.1,1.323.676.676,0,0,0,.1-.007c7.27-1.071,15.711-6.383,15.569-17.833a41.613,41.613,0,0,1,1.168-9.21C103.787,34.87,104.327,32.283,103.237,30.639Z",
    transform: "translate(-44.35 -16.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.84,100.432c-1.462.275-2.865,2.164-4.17,5.609a12.28,12.28,0,0,1-2.834,2.12.666.666,0,1,0,.667,1.152,13.824,13.824,0,0,0,3.1-2.324c3.057-.753,5.248-2.165,5.737-3.713a2.031,2.031,0,0,0-.442-2.033A2.149,2.149,0,0,0,93.84,100.432Zm1.233,2.444c-.246.781-1.478,1.8-3.709,2.52,1.362-3.153,2.408-3.6,2.721-3.656a.724.724,0,0,1,.124-.012.953.953,0,0,1,.7.4.7.7,0,0,1,.164.745Z",
    transform: "translate(-44.77 -50.261)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProwessIcon3);
export default __webpack_public_path__ + "static/media/prowess-icon3.580d70d392777e74065089bd1c77f350.svg";
export { ForwardRef as ReactComponent };